import Http from '../containers/App/Http';
import User from '../Models/User';

const AuthCheck = async () => {
    const um = new User();
    return um.getUserInfo();
};

export default AuthCheck;